import { jsx as _jsx } from "react/jsx-runtime";
const SvgLolKill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M-4.76837e-06 0L0.226747 2.10021L7.79949 9.023L7.01846 9.73109C6.74132 9.98202 6.72693 10.3979 6.98967 10.6626C7.25241 10.9273 7.68791 10.941 7.96505 10.6901L9.10241 9.66235L11.3159 11.7454L11.3151 11.7542C11.3118 11.7921 11.3087 11.8274 11.3087 11.8657C11.3087 12.4913 11.8414 13 12.4965 13C13.1515 13 13.6842 12.4913 13.6842 11.8657C13.6842 11.2401 13.1515 10.7314 12.4965 10.7314C12.4533 10.7314 12.4137 10.7348 12.3705 10.7382L10.2038 8.66896L11.3663 7.62057C11.6435 7.36965 11.6578 6.95373 11.3951 6.68905C11.1324 6.42438 10.6969 6.41063 10.4197 6.66155L9.5991 7.40058L2.33948 0.0996827L-4.76837e-06 0Z",
		fill: "currentColor"
	})
});
export default SvgLolKill;
